import { createTheme } from "@mui/material/styles";

const theme = createTheme({
    typography: {
        fontFamily: "Neue Haas Grotesk Display Pro, Neue Haas Grotesk Text Pro, PP Editorial New, Outfit, sans-serif,",
    },
});

export default theme;
